export const PartValidation = (formData) => {
    const errors = {};

    if (!formData.formData.vc_StockCode || !formData.formData.vc_StockCode.trim()) {
        errors.vc_StockCode = 'This field is required';
    }

    if (!formData.formData.vc_Description || !formData.formData.vc_Description.trim()) {
        errors.vc_Description = 'This field is required';
    }
    if (formData.formData.StockType.toString() === "1") {
        if (!formData.formData.dec_conversion || !formData.formData.dec_conversion.trim()) {
            errors.dec_conversion = 'This field is required';
        }
        if (formData.formData.FK_UnitOfMeasure_ID_Sales.toString() === "0") {
            errors.FK_UnitOfMeasure_ID_Sales = 'This field is required';
        }
        if (formData.formData.FK_UnitOfMeasure_ID_Purchasing.toString() === "0") {
            errors.FK_UnitOfMeasure_ID_Purchasing = 'This field is required';
        }
    }


    return errors;
};

